import { render, staticRenderFns } from "./WidgetMasterContent.vue?vue&type=template&id=4f65e73b&"
import script from "./WidgetMasterContent.vue?vue&type=script&lang=js&"
export * from "./WidgetMasterContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports